
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 31","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.538 3.592h4.228v-1a1.667 1.667 0 013.333 0v1.055a4.001 4.001 0 013.334 3.945v19.333a4 4 0 01-4 4h-36a4 4 0 01-4-4V7.592a4 4 0 014-4h6.894A4.002 4.002 0 0115.099.925h14.667a4.002 4.002 0 013.772 2.667zM22.433 28.258c6.259 0 11.333-5.074 11.333-11.333 0-6.26-5.074-11.333-11.333-11.333-6.26 0-11.334 5.074-11.334 11.333 0 6.26 5.074 11.334 11.334 11.334zm-12-21.666a1 1 0 00-1-1H4.1a1 1 0 100 2h5.333a1 1 0 001-1z"}}),_c('circle',{attrs:{"cx":"22.599","cy":"16.481","r":"7.333"}})])
          )
        }
      }
    